export default __webpack_public_path__ + "static/media/False Present.8048f25f.png";